import React, { useContext } from 'react'

import type { ComplexApiType } from '../../MenuComplexesApi'
import { OrderDataContext } from '../../CafeteriaMenu/OrderData'
import Complex from './Complex'
import styles from './Complexes.module.scss'

type Props = {
  complexes: Array<ComplexApiType>,
  orderFormOpened: boolean,
  balanceLeft?: number,
  loading: boolean,
  personId: number,
  date: string,
}

const Complexes = ({ complexes, orderFormOpened, balanceLeft, loading, personId, date }: Props) => {
  const { isItemInOrder, addToOrder, additionalFreeGuids } = useContext(OrderDataContext)

  return (
    <div className={styles.root}>
      {complexes.map((props) => {
        const { guid, free_for_sale: free } = props
        const updatedProps = {
          ...props,
          free_for_sale: Boolean(free || additionalFreeGuids[guid]),
        }

        return (
          <Complex
            key={guid}
            orderFormOpened={orderFormOpened}
            balanceLeft={balanceLeft}
            addToOrder={addToOrder}
            isAdded={isItemInOrder(guid)}
            loading={loading}
            personId={personId}
            date={date}
            {...updatedProps}
          />
        )
      })}
    </div>
  )
}

export default Complexes
